'use client';

import React, { createContext, useContext } from 'react';

// EWM-253 — carries the per-dealer Algolia Secured API Key minted
// server-side (in the page) down to the client search paths
// (`useAlgoliaProducts`, Insights init). The client never sees the raw
// parent key — only this scoped, signed key.
//
// Re-mint happens via a full page reload on BU/store change (the
// store-and-business-units provider already reloads), so within a render
// tree the value is stable. `validUntil` is exposed so a client can
// detect the rare no-navigation expiry and refresh.

export interface AlgoliaKeyContextShape {
  securedApiKey?: string;
  /** Unix epoch seconds the key expires. */
  validUntil?: number;
}

const AlgoliaKeyContext = createContext<AlgoliaKeyContextShape>({});

const AlgoliaKeyProvider = ({
  securedApiKey,
  validUntil,
  children,
}: React.PropsWithChildren<AlgoliaKeyContextShape>) => (
  <AlgoliaKeyContext.Provider value={{ securedApiKey, validUntil }}>{children}</AlgoliaKeyContext.Provider>
);

export default AlgoliaKeyProvider;

export const useAlgoliaKey = (): AlgoliaKeyContextShape => useContext(AlgoliaKeyContext);
